import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

import euiFormTextruta from 'v-components/euiFormTextruta.vue';
import euiFormLosenstyrka from 'v-components/euiFormLosenstyrka.vue';

import objectToFormData from 'object-to-formdata';

import { Resultat } from 'classes/ResultatClasses';


import { ValidationObserver } from 'vee-validate';

//import TaBortEventuellaQuerystringparametrarFranAdressfaltet from 'TaBortEventuellaQuerystringparametrarFranAdressfaltet';
//TaBortEventuellaQuerystringparametrarFranAdressfaltet.TaBortDirekt();

import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
import VeeValidateRequireChecked from 'VeeValidateRequireChecked';
//import VeeValidateRemote from 'VeeValidateRemote';
VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!
VeeValidateRequireChecked.runOnce();	// Kör funktionen om den inte redan körts!
//VeeValidateRemote.runOnce();	// Kör funktionen om den inte redan körts!


window.ssoAterstallLosen = window.ssoAterstallLosen || {};	// För att undvika ESLint-varningar att den är odefinierad.

//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiFormTextruta,
		euiFormLosenstyrka,
		'validation-observer': ValidationObserver,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		// Reaktiva data:

		losenstyrka: undefined,

		// Obs! Måste stämma med form model som används i controllern:
		aterstallLosenFormModel: window.ssoAterstallLosen.aterstallLosenFormModel,


		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		resultatFranControllern: Object.freeze(Resultat.castFrom(window.ssoAterstallLosen.resultatFranControllern)),
		personEpost: Object.freeze(window.ssoAterstallLosen.personEpost),
	},

	methods: {

		onSpara() {

			// Validera först!
			this.$refs.validationsobserveraren.validate()
				.then((isValid) => {

					if (!isValid) {
						// Om formuläret inte validerar:
						// Då har feltexter visats i formuläret:
						// Bara aborta emittandet.
					}
					else
					{
						// Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/konto/aterstall-losen', {
							formData: objectToFormData(this.aterstallLosenFormModel),
							doljSpinnerOnSuccess: true,
							onSuccessFunction: (resultat) => {

								// Obs! Även vid OK-respons så innehåller Resultat ett meddelande att visa!
								// Visa lyckatmeddelandet:
								this.visaResultatmeddelande(resultat, {
										dialogId: 'innanNavigeringTillInloggningssidan',
										//breddMedEnhet: '40rem',	// Default = '36rem'.
									}
								);
							},
						});
					}
				});
		},

		onMeddelandedialogStangs(dialogId)
		{
			switch (dialogId)
			{
				case 'innanNavigeringTillInloggningssidan':
					{
						// Navigera till inloggningssidan:
						// SKIPPAT: (inkl utloggning före om man är inloggad!):

						// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						// Man kommer direkt till startsidan om man redan är inloggad!
						window.location.href = '/';	//'/konto/logga-in';
						break;
					}
			}
		}
	},


	//== Lifecycle hooks  ================================================================================================================

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	},

	mounted()
	{
		// Programmatisk bind:
		this.$on('meddelandedialog-stangs', this.onMeddelandedialogStangs);

		if (this.resultatFranControllern.AntalMessages > 0)
		{
			// Ett meddelande ska visas (istället för formuläret):
			// Servern returnerade *antingen* ett fel (validering/tekniskt/...) eller ett succeeded-meddelande (ex "anv redan registrerad och nu är även åtkomsten registrerad"):
			// Visa det:

			this.visaResultatmeddelande(this.resultatFranControllern, {
					dialogId: 'innanNavigeringTillInloggningssidan',
				}
			);
		}
	},

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!


export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;


